import type { ProductType } from '@econtractor/types';
import EmptyResult from 'components/others/EmptyResult';
import ProductTableRow from './ProductTableRow';

interface ProductTableBodyProps {
    productsList: ProductType[];
    fetchProducts: (force?: boolean) => Promise<unknown>;
}

const ProductTableBody = ({ productsList, fetchProducts }: ProductTableBodyProps) => {
    return (
        <tbody>
            {productsList?.map((product) => (
                <ProductTableRow key={product.ID} product={product} fetchProducts={fetchProducts} />
            ))}

            {productsList.length === 0 && (
                <tr>
                    <td colSpan={8}>
                        <EmptyResult />
                    </td>
                </tr>
            )}
        </tbody>
    );
};

export default ProductTableBody;
